import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FileService, MainAppService, ApplicationMessagesService } from '@medappsware/shared';
import { MawAuthService } from '@medappsware/maw-auth';
import { environment } from '../environments/environment';
import { CookieConsentService } from './core/services/cookie-consent.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})

export class AppComponent {
  sideNav: boolean = false;
  title = 'Fitness Labs';
    private cookieBannerDelayElapsed = false;

  constructor(
      private readonly mainAppService: MainAppService,
      private readonly fileService: FileService,
      private readonly applicationMessagesService: ApplicationMessagesService,
            public readonly cookieConsentService: CookieConsentService,
      private readonly mawAuthService: MawAuthService,
  ){
      this.mainAppService.setAPIURL(environment.apiURL);
      // Patient self-registration verifies the email with an emailed code (entered in the sign-up
      // popup, or in a "Verify your email" popup when an unfinished registration logs in) instead of
      // an emailed link. Applies to every maw-auth sign-up/login entry point in the app.
      this.mawAuthService.configureFeatures({
          emailCodeRegistration: true,
          registrationPath: '/registration/patient',
      });
      this.fileService.setFilesApiUrl(environment.filesApiUrl);
      this.fileService.setCdnApiUrl(environment.cdnUrl);
      this.mainAppService.setAuthURL(environment.authApiUrl);
      this.mainAppService.setFilesApiUrl(environment.filesApiUrl);
      this.mainAppService.setCdnApiUrl(environment.cdnUrl);

      // Warm the application-messages cache at startup so the first popup doesn't
      // wait on a network call. Fire-and-forget: load() subscribes internally and
      // returns immediately, so it never blocks bootstrap or any other call. It is
      // also idempotent, so the per-popup load() calls become no-ops once this lands.
      this.applicationMessagesService.load();

      setTimeout(() => {
          this.cookieBannerDelayElapsed = true;
      }, 3000);
  }

  get showCookieBanner(): boolean {
      return this.cookieBannerDelayElapsed && !this.cookieConsentService.hasConsentChoice();
  }

  acceptAllCookies(): void {
      this.cookieConsentService.acceptAll();
  }

  rejectNonEssentialCookies(): void {
      this.cookieConsentService.rejectNonEssential();
  }
}
